<template>
  <quagga-js-barcode-reader v-if="settings.barcodeReaderProvider === 'QuaggaJs'"
                            :start-scan="startScan"
                            @barcode-detected="barcodeDetected($event)"></quagga-js-barcode-reader>
  <scandit-barcode-reader v-else-if="settings.barcodeReaderProvider === 'Scandit'"
                          :start-scan.sync="startScan"
                          :license-key="settings.licenseKey"
                          @barcode-detected="barcodeDetected($event)"></scandit-barcode-reader>
  <test-barcode-reader v-else :start-scan="startScan" @barcode-detected="barcodeDetected($event)"></test-barcode-reader>
</template>

<script>
  import QuaggaJsBarcodeReader from "./QuaggaJsBarcodeReader";
  import ScanditBarcodeReader from "./ScanditBarcodeReader";
  import TestBarcodeReader from "./TestBarcodeReader";

  export default {
    name: "BarcodeReader",
    components: {
      QuaggaJsBarcodeReader, ScanditBarcodeReader, TestBarcodeReader
    },
    props: {
      startScan: Boolean,
      settings: {
        type: Object,
        default: () => ({
          licenseKey: '',
          barcodeReaderProvider: 'QuaggaJs',
        }),
        required: false
      },
    },
    mounted: function () {
      //console.log(this.settings);
    },
    methods: {
      barcodeDetected(detectedCode) {
        //console.log("BarcodeReader", detectedCodes);
        if (!detectedCode || detectedCode === '') return;
        this.$emit('barcode-detected', detectedCode);
      },
    },
    watch: {
      startScan: function (n, o) {
        this.$emit('update:startScan', n);
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EcomCore/Components/InputDevices/BarcodeReader.vue